export default "/images/045ffd6dbbb2368c4aeea440efbd3d5c.avif";